module.exports = __webpack_public_path__ + "static/media/not_found.34afe82e.jpg";